import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    Container,
    Typography,
  } from "@mui/material";

  import { Link, useNavigate } from "react-router-dom";
  import { useSelector } from "../store";

  import React, { useEffect } from "react";
  import plus from "../assets/images/website/plus.png";
  
  function Operation() {
    const [expanded, setExpanded] = React.useState(false);
    const navigate = useNavigate()
    const { username } = useSelector((state) => state.auth);

    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  
    const handleChange = (panel) => (event, isExpanded) => {
      setExpanded(isExpanded ? panel : false);
    };
    return (
      <React.Fragment>
        <Container maxWidth="xl">
            <Box
              sx={{
                maxWidth: "1400px",
                padding: {xs: '65px 0px 107px' , lg: "140px 0px"},
                margin: "auto",
                textAlign: "center",
              }}
            >
            
              

              <Typography
                sx={{
                  color: "#000",
                  fontWeight: 700,
                  fontFamily: '"Inter", sans-serif',
                  fontSize: { xs: 36, lg: 54 },
                  lineHeight: { xs: '44px', lg: "65px" },
                  maxWidth: '800px',
                  margin: { xs: 'auto', lg: 0 },
                  textAlign: { xs: 'center', lg: 'start' }
                }}
              >
               How Do I Trade?
              </Typography>
              <Typography
                sx={{
                  color: "#000",
                  fontWeight: 400,
                  fontFamily: '"Inter", sans-serif',
                  fontSize: { xs: 18, lg: 22 },
                  padding: "24px 0px 60px",
                  textAlign: { xs: 'center', lg: 'start' }
                }}
              >
              After becoming a member of Povego, you can easily buy and sell by transferring Turkish Lira from your bank account, and track your total assets and account movements. You can only transfer money to Povego from your own bank account. Transfers made from third-party accounts or accounts opened with a tax identification number are not accepted.<br/><br/>
              If you are going to perform an EFT transaction, you must enter the recipient name as "Povego A.S.". If you are going to make a wire transfer, the recipient name will automatically appear on the screen after entering the IBAN number.<br/><br/>
              After entering the amount you want to send, you can complete your transaction by leaving the transaction description blank. If your bank does not allow you to leave the transaction description blank, you can enter your name and surname information.

<br/><br/>
              You can easily track your Turkish Lira deposit transaction from the Account Movements section in the panel. The amount you deposited will be transferred to your account shortly after it reaches the Povego account.<br/><br/>
              </Typography>
            </Box>
          </Container>
      </React.Fragment>
    );
  }
  
  export default Operation;
  
